<!-- Cabeçalho -->
<div class="row mb-4">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="mb-1">
          @if (icon) {
            <i [class]="icon + ' me-2'"></i>
          }
          {{ title }}
        </h2>
        @if (subtitle) {
          <p class="text-muted mb-0">{{ subtitle }}</p>
        }
      </div>
    </div>
  </div>
</div>
